import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet, useLoaderData } from "react-router-dom";
import Header from "../components/Header/Header";
import axios from "axios";
import { setManualTypeReducer } from "../store/slice/manualTypeSlice";
import Footer from "../components/Footer/Footer";
import SideMenu from "../components/SideMenu/SideMenu";
import { ArrowRight } from "react-bootstrap-icons";
import "./MainPage.scss";

const MainPage = () => {
  const storedManualType = useSelector(
    (state) => state.manualTypeChecker.manualType
  );

  const { manualType } = useLoaderData();
  const dispatch = useDispatch();

  useEffect(() => {
    const manualTypeInterceptor = axios.interceptors.request.use((config) => {
      config.baseURL =
        process.env.NODE_ENV === "development" ? "http://localhost:9999" : "";
      if (
        config.url.startsWith("/api/manual") ||
        config.url.startsWith("/api/snb")
      ) {
        config.url = `/api/${manualType}/${config.url.substring(5)}`;
      }
      return config;
    });
    dispatch(setManualTypeReducer({ manualType }));
    return () => {
      axios.interceptors.request.eject(manualTypeInterceptor);
    };
    // eslint-disable-next-line
  }, [manualType]);

  if (storedManualType)
    return (
      <>
        <Header />
        <SideMenu />
        <div className="main">
          <Outlet />
          <Footer />
        </div>
      </>
    );
  else
    return (
      <>
        <div className="main-platform-switch-container">
          <Link className="platform-switch-menu" to="/g">
            G Cloud 매뉴얼
            <ArrowRight className="platform-switch-menu-icon" />
          </Link>
          <Link className="platform-switch-menu" to="/kt">
            KT Cloud 매뉴얼
            <ArrowRight className="platform-switch-menu-icon" />
          </Link>
        </div>
      </>
    );
};

export default MainPage;
